export enum NeedsAnalysisValue {
    VeryLow = -2,
    Low = -1,
    Average = 0,
    High = 1,
    VeryHigh = 2
}